import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {makeStyles, withStyles} from "@material-ui/core/styles";
// import {REACT_APP_API_URL} from

// imported components
import EditableTable from "../presentational_components/table_component";
import ClusterTable from "../presentational_components/cluster_table";
import AttrTable from "../presentational_components/predict_table";
import LoadingIndicator from "../presentational_components/loading_indicator";
import {trackPromise} from "react-promise-tracker";
import AlertModal from "../presentational_components/modal";
import Introduction from "../presentational_components/intro.js";
// default table data
import {input_data} from "../faux_data/joint_clusters"; //{music:{[],[]} }, {electronics:{[],[]} }


//Material UI component imports
import {Stepper, Step, StepLabel, StepContent} from "@material-ui/core/";
import {Paper, Typography} from "@material-ui/core/";
import Icon from "@material-ui/core/Icon";
import InputIcon from "@material-ui/icons/Input";
import CompareArrowsOutlinedIcon from "@material-ui/icons/CompareArrowsOutlined";
import EditAttributesIcon from "@material-ui/icons/EditAttributes";
//classes for step styles
import {
  InputSubmitButton,
  ResetTableButton,
  InputStepContainer,
  Button,
  ButtonContainer,
  DataSelectBtn,
  NextButton,
  BackButton,
  StepText,
  TableWrapper,
  // StartButton,
  InstructionTxt
} from "../styles/stepper_styles.js";

// import {IntroPar, Box} from "../styles/intro_styles";

const DEMO_API = process.env.REACT_APP_API_URL

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      margin: "0px auto"
    }
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
    paddingTop: 20
  },
  resetContainer: {
    padding: theme.spacing(3)
  },
  stepper: {
    marginTop: "0px",
    [theme.breakpoints.up("lg")]: {
      margin: "0px auto",
      width: "80%",
      height: "100%",
      position: "relative"
    },
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      margin: "0px auto"
    }
  }
}));
const styles = (theme) => ({
  root: {
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      margin: "0px auto"
    }
  },
  button: {
    margin: "10px"
  },
  startButton: {
    margin: "10px",
    marginLeft: "30px"
  },
  submitButton: {
    verticalAlign: "bottom",
    margin: "15px"
  },
  stepper: {
    marginTop: "0",
    [theme.breakpoints.down("lg")]: {
      margin: "0px auto",
      width: "80%",
      height: "100%",
      position: "relative"
    },
    [theme.breakpoints.up("lg")]: {
      width: "80%",
      margin: "0px auto"
    }
  },
  stepContents: {
    padding: "100px",
    position: "relative",
    fontFamily: "Rubik-Medium"
  },
  contents: {
    margin: "20px"
    // fontSize: "16px"
  },
  mappings: {
    marginRight: "50px",
    padding: "10px 30px",
    background: "#F8F8F8"
  },
  headers: {
    paddingLeft: "10px 30px"
  },
  header: {
    margin: "7px 0px",
    fontFamily: "Rubik"
  },
  actionsContainer: {
    marginBottom: theme.spacing(1),
    width: "700px",
    textAlign: "right",
    margin: "0px auto",
    paddingRight: "10px"
  },
  resetContainer: {
    padding: theme.spacing(3)
  },
  paper: {
    margin: "2px 2px",
    padding: "3px 2px",
    background: "#F8F8F8"
  },
  label: {
    fontSize: "2em",
    fontFamily: "Rubik",
    fontWeight: 600
  },
  title: {
    fontSize: "1.4em",
    padding: "10px 30px",
    color: "#FFFFFF",
    fontFamily: "Rubik-Medium"
  },
  description: {
    fontFamily: "Rubik-Medium",
    fontSize: "1.2em",
    padding: "10px 54px",
    width: "90%"
  },
  field: {
    padding: "8px 0px"
  },
  padding: {
    width: 24,
    height: 46
  },
  inlineStep: {
    display: "inline-block",
    padding: "10px 20px",
    verticalAlign: "top"
  },
  blockStep: {
    display: "block",
    padding: "40px 20px"
  },
  gridList: {
    margin: "4px 0px"
  },
  heading: {
    fontFamily: "Rubik-Medium",
    fontWeight: "bold",
    padding: "20px",
    fontSize: "16px"
  }
});

class VerticalStepper extends Component {
  constructor(props) {
    let copy_input = JSON.parse(JSON.stringify(input_data.music.rows));
    super(props);
    this.state = {
      activeStep: -1,
      steps: [],
      input_rows: input_data.music.rows,
      update_input_rows: copy_input,
      input_columns: input_data.music.columns,
      clusters: [],
      backActive: false,
      nextActive: false,
      resetTable: false,
      inputActive: true,
      inputSwapActive: true,
      domain: "music",
      task: "Structured/iTunes-Amazon",
      selectedClusters: null,
      modalOpen: false
    };
    this.getStepContent = this.getStepContent.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleResetInput = this.handleResetInput.bind(this);
    this.handleReset = this.handleReset.bind(this);
    this.predictFetch = this.predictFetch.bind(this);
    this.updateRows = this.updateRows.bind(this);
    this.getSelectedClusters = this.getSelectedClusters.bind(this);
    this.setModalState = this.setModalState.bind(this);
  }

  componentDidMount() {
    this.initializeSteps();
  }

  //sets the stepper headers.
  initializeSteps() {
    let taskSpec = {
      steps: [
        {
          id: 0,
          isActive: () => {
            return this.state.activeStep >= 0;
          },
          title: "Choose your Dataset",
          icony: <InputIcon />,
          instructions: ""
        },
        {
          id: 1,
          isActive: () => {
            return this.state.activeStep >= 1;
          },
          title: "View Matching Entities",
          icony: <CompareArrowsOutlinedIcon />,
          instructions: ""
        },
        {
          id: 2,
          isActive: () => {
            return this.state.activeStep >= 2;
          },
          title: "View Confidence Scores",
          icony: <EditAttributesIcon />,
          instructions: ""
        }
      ]
    };
    this.setState({steps: taskSpec.steps});
  }

  //works in cluster_table.js when a row is added or removed, resets the row data.
  updateRows(update) {
    this.setState({update_input_rows: update});
  }

  //works in cluster_table.js when selected.length === 2
  getSelectedClusters(clusters) {
    this.setState({selectedClusters: clusters});
  }

  // handles changing input data when clicking on domain (music & electronics) buttons
  setInput(domain, reset) {
    //data domain button onClick to toggle data input & reset table btn click.
    let task =
      domain === "music" ? "Structured/iTunes-Amazon" : "Textual/Abt-Buy";

    let copy_input = JSON.parse(JSON.stringify(input_data[domain].rows));
    if (!reset) {
      this.setState({
        update_input_rows: copy_input,
        input_columns: input_data[domain].columns,
        domain: domain,
        task: task
      });
    } else {
      this.setState({
        update_input_rows: copy_input
      });
    }
    this.getStepContent(0);
  }

  //based on activeStep, gets the contents of the step.
  getStepContent(step) {
    const classes = useStyles;
    switch (step) {
      case 0:
        return (
          <div className={classes.inlineStep}>
            <InstructionTxt>
              Select a dataset to apply matching. The music dataset contains
              information related to albums, and the electronics dataset
              contains products in the electronics category.
              <br />
              <br />
              Feel free to edit the data table by adding a new row, or editing
              values in cells of existing rows. You can always reset to original
              data by clicking Reset Table.
              <br />
              <br />
              When done click Submit to perform Ditto matching.
            </InstructionTxt>
            <InputStepContainer>
              <ButtonContainer>
                <DataSelectBtn
                  inputSwapActive={this.state.inputSwapActive}
                  className={classes.button}
                  onClick={() => {
                    this.setInput("music");
                  }}
                >
                  Music
                </DataSelectBtn>
                <DataSelectBtn
                  inputSwapActive={this.state.inputSwapActive}
                  className={classes.button}
                  onClick={() => {
                    this.setInput("electronics");
                  }}
                >
                  Electronics
                </DataSelectBtn>
              </ButtonContainer>
              <EditableTable
                rows={this.state.update_input_rows}
                columns={this.state.input_columns}
                onUpdate={this.updateRows}
                activeStep={this.state.activeStep}
              />
            </InputStepContainer>
          </div>
        );
      case 1:
        return (
          <div className={classes.inlineStep}>
            <InstructionTxt>
              Matching entities are indicated by the same cluster ID. See how
              Ditto is flexible in matching entities.
              <br />
              <br /> Optionally, you can also select two rows to view the
              confidence scores to examine matching in detail.
            </InstructionTxt>
            <TableWrapper>
              <LoadingIndicator area="predict-table-area" />
              <ClusterTable
                columns={this.state.input_columns}
                data={this.state.clusters}
                activeStep={this.state.activeStep}
                getSelected={this.getSelectedClusters}
              />
            </TableWrapper>
          </div>
        );
      case 2:
        return (
          <div id="third" className={classes.inlineStep}>
            <InstructionTxt>
              See below for the match confidence.
              <br />
              <br />
              Optionally, you can try out the impact of cell values and columns
              on the confidence score by removing a column or removing
              individual values in cells.
            </InstructionTxt>
            <TableWrapper>
              <AttrTable
                predictFetch={this.predictFetch}
                attr_scores={this.state.attribute_scores}
                cluster_pairs={this.state.cluster_pairs}
                columns={this.state.input_columns}
              />
            </TableWrapper>
          </div>
        );

      default:
        return "Unknown step";
    }
  }

  //handle missing row keys for empty field changes.
  handleClusterInput() {
    let rows = this.state.update_input_rows;
    let columns = this.state.input_columns;

    rows.map((row, i) => {
      columns.map((col) => {
        if (!row[col.name]) {
          rows[i][col.name] = "";
        }
      });
      delete row["default"];
    });
    return rows;
  }

  //alert modal
  setModalState() {
    let modalState = this.state.modalOpen;
    modalState = !modalState;
    this.setState({
      modalOpen: modalState
    });
  }

  //next button action
  handleNext() {
    let addStep = this.state.activeStep + 1;
    if (addStep === 0) {
      console.log("step 0", addStep);
      this.setState({
        activeStep: addStep
      });
      this.getStepContent(0);
    }
    let activeStep = addStep;
    let backActivated = activeStep >= 1 ? true : false;
    let query_type;
    let input;
    if (activeStep === 1) {
      let sorted_input = this.handleClusterInput();
      query_type = "cluster";
      input = JSON.parse(JSON.stringify(sorted_input));
      input.map((inp) => {
        delete inp["id"];
      });
      this.clusterFetch(query_type, input);
      this.setState({
        activeStep: activeStep,
        backActive: backActivated,
        nextActive: true,
        inputSwapActive: false
      });
    } else if (activeStep === 2) {
      query_type = "predict";
      if (
        !this.state.selectedClusters ||
        this.state.selectedClusters.length < 2
      ) {
        this.setModalState();
      } else {
        input = JSON.parse(JSON.stringify(this.state.selectedClusters));
        this.predictFetch(query_type, input, false);
        this.getStepContent(activeStep);
      }
    }
  }
  //back button action
  handleBack() {
    let current = this.state.activeStep;
    let swapactive;
    let nextactive;
    if (this.state.activeStep === 0) {
      current = -1;
    } else {
      current = this.state.activeStep - 1;
      nextactive = current < 2 ? true : false;
      swapactive = current === 0 ? true : false;
    }
    this.setState({
      activeStep: current,
      nextActive: nextactive,
      inputSwapActive: swapactive,
      selectedClusters: []
    });
  }

  //resets the table on "Reset Table" button
  handleResetInput() {
    this.setInput(this.state.domain, true);
  }

  //Resets the app back to the first table while maintaining any edits in the first table.
  handleReset() {
    this.setState({
      activeStep: 0,
      inputSwapActive: true
    });
    this.getStepContent(0);
  }

  //fetch for table 2 clusters
  async clusterFetch(query_type, input) {
    let url = `${DEMO_API}${query_type}`;
    let params = JSON.stringify({task: this.state.task});
    let jsonify_data = JSON.stringify(input);
    const formData = new FormData();
    formData.append("params", params);
    formData.append("data", jsonify_data);
    trackPromise(
      fetch(url, {
        mode: "cors",
        method: "POST",
        body: formData
      })
        .then((response) => response.json())
        .then((data) => {
          this.setState({
            clusters: data
          });
        })
        .catch((error) => console.log(error))
    );
  }

  formatPredictInput(cluster_input) {
    let clusters = JSON.parse(JSON.stringify(cluster_input));
    let submission = {left: clusters[0], right: clusters[1]};
    delete submission.left["cluster_id"];
    delete submission.right["cluster_id"];
    return submission;
  }

  //fetch for table 3 attribute scores, called on table load and every cell click.
  async predictFetch(query_type, input, mod) {
    let predict_input;
    predict_input = this.formatPredictInput(input);
    if (!predict_input || Object.keys(predict_input).length === 0) {
      this.setState({
        attribute_scores: {},
        cluster_pairs: {},
        activeStep: 2
      });
      return;
    }

    let url = `${DEMO_API}${query_type}`;
    let params = JSON.stringify({task: this.state.task});
    let jsonify_data = JSON.stringify(predict_input);
    const formData = new FormData();
    formData.append("params", params);
    formData.append("data", jsonify_data);
    trackPromise(
      fetch(url, {
        mode: "cors",
        method: "POST",
        body: formData
      })
        .then((response) => response.json())
        .then((data) => {
          //=== mod indicates the original clusters were modified in table 3.
          mod
            ? this.setState({
                attribute_scores: data
              })
            : this.setState({
                attribute_scores: data,
                cluster_pairs: predict_input,
                activeStep: 2,
                backActive: true,
                nextActive: false
              });
        })
        .catch((error) => console.log(error))
    );
  }

  render() {
    const classes = useStyles;
    return (
      <div className={classes.stepper}>
        <LoadingIndicator />
        <AlertModal
          setModalState={this.setModalState}
          isOpen={this.state.modalOpen}
        />
        <Paper square elevation={2} className={classes.paper} >
          <Introduction
            activeStep={this.state.activeStep}
            handleNext={this.handleNext}
            />
          <Stepper
            activeStep={this.state.activeStep}
            orientation="vertical"
            className={classes.stepper}
          >
            {this.state.steps.map((step) => (
              <Step key={step.id} active={step.isActive()}>
                <StepLabel StepIconComponent={() => <Icon>{step.icony}</Icon>}>
                  <Typography
                    variant="body1"
                    variantMapping={{body1: "span"}}
                    className={classes.label}
                    color="textPrimary"
                  >
                    <StepText>{step.title}</StepText>
                  </Typography>
                </StepLabel>
                <StepContent>
                  {this.getStepContent(step.id)}
                  {this.state.activeStep === 0 && (
                    <div className={classes.actionsContainer}>
                      <InputSubmitButton
                        variant="contained"
                        background="linear-gradient(.87turn, #187039, #a3d251)"
                        onClick={this.handleNext}
                        inputActive={this.state.inputActive}
                      >
                        Submit
                      </InputSubmitButton>
                      <ResetTableButton
                        variant="contained"
                        background="linear-gradient(.87turn, #187039, #a3d251)"
                        onClick={this.handleResetInput}
                        className={classes.button}
                        resetTableActive={this.state.resetTable}
                      >
                        Reset Table
                      </ResetTableButton>
                    </div>
                  )}

                  {this.state.activeStep === step.id &&
                    this.state.activeStep === 1 && (
                      <div className={classes.actionsContainer}>
                        <NextButton
                          variant="contained"
                          background="linear-gradient(.87turn, #187039, #a3d251)"
                          onClick={this.handleNext}
                          // className={classes.button}
                          nextActive={this.state.nextActive}
                        >
                          Submit
                        </NextButton>
                        <BackButton
                          variant="contained"
                          background="linear-gradient(.87turn, #187039, #a3d251)"
                          onClick={this.handleBack}
                          // className={classes.button}
                          backActive={this.state.backActive}
                        >
                          Back
                        </BackButton>
                      </div>
                    )}

                  {this.state.activeStep === step.id &&
                    this.state.activeStep === this.state.steps.length - 1 && (
                      <Paper
                        square
                        elevation={0}
                        className={classes.resetContainer}
                      >
                        <div className={classes.actionsContainer}>
                          <Button
                            variant="contained"
                            background="linear-gradient(.87turn, #187039, #a3d251)"
                            onClick={this.handleReset}
                            className={classes.button}
                          >
                            Reset
                          </Button>
                          <BackButton
                            variant="contained"
                            background="linear-gradient(.87turn, #187039, #a3d251)"
                            onClick={this.handleBack}
                            className={classes.button}
                            backActive={this.state.backActive}
                          >
                            Back
                          </BackButton>
                        </div>
                      </Paper>
                    )}
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Paper>
      </div>
    );
  }
}

export default withRouter(withStyles(styles)(VerticalStepper));
